module.exports = __webpack_public_path__ + "img/mushrooms.7b7c97a3.jpg";